import config from "../../config/config";

export const footerData = [
    {
        gnbFooterLinksData: [
            {
                linksText: "About Us",
                linksUrl: "https://www.shiksha.com/about",
            },
            {
                linksText: "Management Team",
                linksUrl: "https://www.shiksha.com/team",
            },
            {
                linksText: "Shiksha Authors",
                linksUrl: "https://www.shiksha.com/shiksha-authors",
            },
            {
                linksText: "Careers",
                linksUrl: "https://careers.shiksha.com/",
            },
            {
                linksText: "FAQs",
                linksUrl: "https://faq.shiksha.com/",
            },
            {
                linksText: "Contact Us",
                linksUrl: "mailto:studyabroad@shiksha.com",
            },
            {
                linksText: "Our Vision Statement",
                linksUrl: `${config.SHIKSHA_STUDYABROAD_HOME}/our-vision`,
            },
        ],
        group: "About Shiksha",
    },
    {
        gnbFooterLinksData: [
            {
                linksText: "Infoedge.in",
                linksUrl: "http://www.infoedge.in",
                linksRel: "nofollow",
            },
            {
                linksText: "Shiksha.com",
                linksUrl: "http://www.shiksha.com",
            },
            {
                linksText: "Naukri.com",
                linksUrl: "http://www.naukri.com",
                linksRel: "nofollow",
            },
            {
                linksText: "Firstnaukri.com",
                linksUrl: "http://www.firstnaukri.com",
                linksRel: "nofollow",
            },
            {
                linksText: "Naukrigulf.com",
                linksUrl: "http://www.naukrigulf.com",
                linksRel: "nofollow",
            },
            {
                linksText: "99acres.com",
                linksUrl: "http://www.99acres.com",
                linksRel: "nofollow",
            },
            {
                linksText: "Jeevansathi.com",
                linksUrl: "http://www.jeevansathi.com",
                linksRel: "nofollow",
            },
            {
                linksText: "AmbitionBox.com",
                linksUrl: "http://www.ambitionbox.com",
                linksRel: "nofollow",
            },
            {
                linksText: "Naukri Learning",
                linksUrl: "https://www.naukri.com/learning/",
                linksRel: "nofollow",
            },
        ],
        group: "Our Group",
    },
    // {
    //     gnbFooterLinksData: [
    //         {
    //             linksText: "Zomato.com",
    //             linksUrl: "http://www.zomato.com",
    //         },
    //         {
    //             linksText: "Policybazaar.com",
    //             linksUrl: "http://www.policybazaar.com",
    //         },
    //         {
    //             linksText: "Mydala.com",
    //             linksUrl: "https://www.mydala.com",
    //         },
    //         {
    //             linksText: "HappilyUnmarried.com",
    //             linksUrl: "http://www.happilyunmarried.com/",
    //         },
    //         {
    //             linksText: "Canvera.com",
    //             linksUrl: "http://www.canvera.com/",
    //         },
    //     ],
    //     group: "Partner Sites",
    // },
    {
        gnbFooterLinksData: [
            {
                linksText: "Client Login",
                linksUrl: "https://enterprise.shiksha.com/enterprise/Enterprise/loginEnterprise",
            },
            {
                linksText: "Advertising/Sales enquiries",
                linksUrl: "#",
            },
            {
                linksText: "AIRC - Certification for recruitment services",
                linksUrl: "https://www.airc-education.org/airc-certified-agencies",
            },
        ],
        group: "Enterprise",
    },
];
